import React, {lazy, Suspense, useContext, useEffect} from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import AdminLayout from "layouts/Admin/Admin.js";
import TenantSelector from "views/TenantSelector";
import LoaderComponent from 'components/common/Loader';
import { UserSettingsContext } from "contexts/UserSettingsContext";
import { useTranslation } from 'react-i18next';
import ErrorPage from "views/errors/ErrorPage";
import NoAccessPage from "views/errors/NoAccessPage";
import ApiError from "components/common/ApiError";
import AcceptInvitation from "components/modules/tenants/AcceptInvitation";

const SettingsWizard = lazy(() => import("views/SettingsWizard"));
const Chat = lazy(() => import("views/Chat"));

const settingsWizardRoute = (tenantId) => (
    <Route path="/settings-wizard" element={(
        <Suspense fallback={<LoaderComponent />}>
            <SettingsWizard key={tenantId} />
        </Suspense>
    )}/>)

const AuthenticatedRoutes = () => {
    const { t } = useTranslation();
    const { tenant, userSettings, isLoading, error, errorTenant, errorUserId, invitation, userId } = useContext(UserSettingsContext);

    if (error) return <ErrorPage message={t('error.loadingSettings')} />;
    if (errorTenant) return <ErrorPage message={errorTenant} />;
    if (errorUserId) return <ErrorPage message={errorUserId} />;
    if (invitation.error) return <ApiError retryFetch={invitation.refetch} errorMessage={t('login.errorToken')} />
    if( userId === null || isLoading || invitation.isLoading) return <LoaderComponent/>;

    return (
        <Routes>
            <Route path="/error" element={<ErrorPage />} />
            <Route path="/invite" element={<AcceptInvitation/>}/>
            <Route path="/no-access" element={<NoAccessPage />} />
            <Route path="/select-tenant" element={<TenantSelector/>}/>
            {!tenant?.id ? (
                <Route path="*" element={<Navigate to="/select-tenant" replace />} />
            ) : !tenant?.is_setup_done ? (
                <>
                    {settingsWizardRoute(tenant.id)}
                    <Route path="*" element={<Navigate to="/settings-wizard" replace />} />
                </>
            ) : (
                <>
                    <Route path="/chat/:chatId" element={(
                        <Suspense fallback={<LoaderComponent />}>
                            <Chat/>
                        </Suspense> )} />
                    <Route path="/admin/*" element={<AdminLayout key={tenant.id} />} />
                    {settingsWizardRoute(tenant.id)}
                    <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
                </>
            )}
        </Routes>
    );
};

export default AuthenticatedRoutes;
